module.exports = __webpack_public_path__ + "assets/img/bg2.9dff6531.png";